// A section's sort order — « Trier : Chambre · Nom · Heure » (operator
// 2026-09-25). Each section of Arrivées and Départs keeps its own, and opens on
// the default the desk reads it by.

export interface SortOption<K extends string> {
  key: K;
  label: string;
}

export interface SortChipsProps<K extends string> {
  value: K;
  options: SortOption<K>[];
  onChange: (key: K) => void;
  /** The section it sorts, for the group's accessible name. */
  section: string;
}

export function SortChips<K extends string>({ value, options, onChange, section }: SortChipsProps<K>) {
  return (
    <span className="pms-sort pms-no-print" role="group" aria-label={`Trier ${section}`}>
      <span className="pms-sub">Trier :</span>
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          className={`pms-sort-chip${value === o.key ? ' is-active' : ''}`}
          aria-pressed={value === o.key}
          onClick={() => onChange(o.key)}
        >
          {o.label}
        </button>
      ))}
    </span>
  );
}
